// knight units
import copperArmor from "src/assets/images/knight/v1/rank1/light/armor.png";
import copperHelmet from "src/assets/images/knight/v1/rank1/light/helmet.png";
import copperShield from "src/assets/images/knight/v1/rank1/light/shield.png";
import copperWeapon from "src/assets/images/knight/v1/rank1/light/weapon.png";

import silverArmor from "src/assets/images/knight/v1/rank2/light/armor.png";
import silverHelmet from "src/assets/images/knight/v1/rank2/light/helmet.png";
import silverShield from "src/assets/images/knight/v1/rank2/light/shield.png";
import silverWeapon from "src/assets/images/knight/v1/rank2/light/weapon.png";

import goldArmor from "src/assets/images/knight/v1/rank3/light/armor.png";
import goldHelmet from "src/assets/images/knight/v1/rank3/light/helmet.png";
import goldShield from "src/assets/images/knight/v1/rank3/light/shield.png";
import goldWeapon from "src/assets/images/knight/v1/rank3/light/weapon.png";

import diamondArmor from "src/assets/images/knight/v1/rank4/light/armor.png";
import diamondHelmet from "src/assets/images/knight/v1/rank4/light/helmet.png";
import diamondShield from "src/assets/images/knight/v1/rank4/light/shield.png";
import diamondWeapon from "src/assets/images/knight/v1/rank4/light/weapon.png";

import crystalArmor from "src/assets/images/knight/v1/rank5/light/armor.png";
import crystalHelmet from "src/assets/images/knight/v1/rank5/light/helmet.png";
import crystalShield from "src/assets/images/knight/v1/rank5/light/shield.png";
import crystalWeapon from "src/assets/images/knight/v1/rank5/light/weapon.png";

// knight badge
import limitedBadge from "src/assets/images/knight/other/limited_badge.png";
import copperBadge from "src/assets/images/knight/v1/rank1/rank.png";
import silverBadge from "src/assets/images/knight/v1/rank2/rank.png";
import goldBadge from "src/assets/images/knight/v1/rank3/rank.png";
import diamondBadge from "src/assets/images/knight/v1/rank4/rank.png";
import crystalBadge from "src/assets/images/knight/v1/rank5/rank.png";

// knight full
import copperFull from "src/assets/images/knight/other/copper_full.png";
import crystalFull from "src/assets/images/knight/other/crystal_full.png";
import diamondFull from "src/assets/images/knight/other/diamond_full.png";
import goldFull from "src/assets/images/knight/other/gold_full.png";
import silverFull from "src/assets/images/knight/other/silver_full.png";

// arena img
import arenaTravaCopper from "src/assets/images/knight/arena/arena_trava_1.png";
import arenaTravaSilver from "src/assets/images/knight/arena/arena_trava_2.png";
import arenaTravaGold from "src/assets/images/knight/arena/arena_trava_3.png";
import arenaTravaDiamond from "src/assets/images/knight/arena/arena_trava_4.png";
import arenaTravaCrystal from "src/assets/images/knight/arena/arena_trava_5.png";

// hand img
import copperHand from "src/assets/images/knight/v1/rank1/items/hand.png";
import silverHand from "src/assets/images/knight/v1/rank2/items/hand.png";
import goldHand from "src/assets/images/knight/v1/rank3/items/hand.png";
import diamondHand from "src/assets/images/knight/v1/rank4/items/hand.png";
import crystalHand from "src/assets/images/knight/v1/rank5/items/hand.png";

// shirt img
import copperShirt from "src/assets/images/knight/v1/rank1/items/armor.png";
import silverShirt from "src/assets/images/knight/v1/rank2/items/armor.png";
import goldShirt from "src/assets/images/knight/v1/rank3/items/armor.png";
import diamondShirt from "src/assets/images/knight/v1/rank4/items/armor.png";
import crystalShirt from "src/assets/images/knight/v1/rank5/items/armor.png";

// head img
import copperHead from "src/assets/images/knight/v1/rank1/items/helmet.png";
import silverHead from "src/assets/images/knight/v1/rank2/items/helmet.png";
import goldHead from "src/assets/images/knight/v1/rank3/items/helmet.png";
import diamondHead from "src/assets/images/knight/v1/rank4/items/helmet.png";
import crystalHead from "src/assets/images/knight/v1/rank5/items/helmet.png";

// sword img
import copperSword from "src/assets/images/knight/v1/rank1/items/sword.png";
import silverSword from "src/assets/images/knight/v1/rank2/items/sword.png";
import goldSword from "src/assets/images/knight/v1/rank3/items/sword.png";
import diamondSword from "src/assets/images/knight/v1/rank4/items/sword.png";
import crystalSword from "src/assets/images/knight/v1/rank5/items/sword.png";

// shield img
import copperShieldV2 from "src/assets/images/knight/v1/rank1/items/shield.png";
import silverShieldV2 from "src/assets/images/knight/v1/rank2/items/shield.png";
import goldShieldV2 from "src/assets/images/knight/v1/rank3/items/shield.png";
import diamondShieldV2 from "src/assets/images/knight/v1/rank4/items/shield.png";
import crystalShieldV2 from "src/assets/images/knight/v1/rank5/items/shield.png";

// special knights
import aleisterBgFull from "src/assets/images/knight/special/aleister/full.gif";
import aleisterNoBg from "src/assets/images/knight/special/aleister/knight.png";
import aleisterBg from "src/assets/images/knight/special/aleister/part.gif";
import aleisterBadge from "src/assets/images/knight/special/aleister/rank.png";

import johannaBgFull from "src/assets/images/knight/special/johanna/full.gif";
import johannaNoBg from "src/assets/images/knight/special/johanna/knight.png";
import johannaBg from "src/assets/images/knight/special/johanna/part.gif";
import johannaBadge from "src/assets/images/knight/special/johanna/rank.png";

import techfiBgFull from "src/assets/images/knight/special/techfi/full.gif";
import techfiNoBg from "src/assets/images/knight/special/techfi/knight.png";
import techfiBg from "src/assets/images/knight/special/techfi/part.gif";
import techfiBadge from "src/assets/images/knight/special/techfi/rank.png";

import noelBgFull from "src/assets/images/knight/special/noel/full.png";
import noelNoBg from "src/assets/images/knight/special/noel/knight.png";
import noelBadge from "src/assets/images/knight/special/noel/rank.png";

import todBgFull from "src/assets/images/knight/special/tod/full.gif";
import todNoBg from "src/assets/images/knight/special/tod/knight.png";
import todBg from "src/assets/images/knight/special/tod/part.gif";
import todBadge from "src/assets/images/knight/special/tod/rank.png";

import { environment } from "src/configs/constance";

export const rarities = ["", "copper", "silver", "gold", "diamond", "crystal", "limited"];
export const types = ["", "helmet", "armor", "weapon", "shield"];
export const sets = ["", "genesis"];

let knightAssetsMapping = {
  genesis: {
    copper: {
      units: {
        helmet: {
          img: copperHelmet,
          description:
            "A generic copper helmet. Although it looks old and rusty, it is imbued with the power of the Lending Pool, and still better than nothing in the midst of the battlefield.",
        },
        armor: {
          img: copperArmor,
          description:
            "A generic copper armor. Looks plain and boring, but most knights learn to appreciate it under the dragon's fiery breath.",
        },
        weapon: {
          img: copperWeapon,
          description:
            "A generic copper sword. Even with its loose hilt and cracked edge, the blessing of the Lending Pool still enables it to tear through dragons' flesh.",
        },
        shield: {
          img: copperShield,
          description:
            "A generic copper shield. Smart knights would never venture out to the battlefield without a shield, however unreliable it may look.",
        },
      },
      badge: copperBadge,
      full: copperFull,
      palette: {
        primary: "#EB7A00",
      },
      arena: arenaTravaCopper,
      hand: copperHand,
      shirt: copperShirt,
      head: copperHead,
      sword: copperSword,
      shield: copperShieldV2,
      name: "bronze",
      fullName: "Knight Apprentice",
      description:
        "These knights-in-training are the new recruitments of the Order of the Holy Knight of Trava, the fresh blood of the Kingdom. Despite the obvious lack of combat experience, Knight Apprentices are all determined and resolved to protect the Kingdom and their families.",
    },
    silver: {
      units: {
        helmet: {
          img: silverHelmet,
          description:
            "A helmet forged from fine silver. On its top lie the signature horns, which symbol certain victory and eternal triumph in the Kingdom of Trava.",
        },
        armor: {
          img: silverArmor,
          description:
            "An armor forged from fine silver. Usually a reward for young knights graduated with excellency from University of Trava Knight.",
        },
        weapon: {
          img: silverWeapon,
          description:
            "A sword forged from fine silver. Its double-edged and jagged blade ensures a painful experience for the dragons… or the user, should he handle carelessly.",
        },
        shield: {
          img: silverShield,
          description:
            "A shield forged from fine silver. Lightweight and easy to handle, it is a very popular choice among young knights.",
        },
      },
      badge: silverBadge,
      full: silverFull,
      palette: {
        primary: "#C8C8C8",
      },
      arena: arenaTravaSilver,
      hand: silverHand,
      shirt: silverShirt,
      head: silverHead,
      sword: silverSword,
      shield: silverShieldV2,
      name: "silver",
      fullName: "Knight Sergeant",
      description:
        "Only those of exceptional skills and techniques could graduate from the renowned Militari Academia of Trava Kingdom, and those who graduate are promoted to Knight Sergeant. These knights serve as the main force of the Kingdom, the Spear, the Shield, the Armor of which the Kingdom uses to fight the fierce dragons.",
    },
    gold: {
      units: {
        helmet: {
          img: goldHelmet,
          description:
            "An exceptional helmet made of pure gold. Its quality ensures high-grade protection against the intense heat of dragon’s breath.",
        },
        armor: {
          img: goldArmor,
          description:
            "An exceptional armor made of pure gold. Reinforced with spiked shoulders, this armor deters even the most ferocious foes from entering close-quarter combat with the wielder.",
        },
        weapon: {
          img: goldWeapon,
          description:
            "An exceptional axe made of pure gold. Wielded by the fiercest of warriors, the frontal bit is forged to slice through dragons’ skins, while the hindmost tip is forged to pierce into their dying hearts.",
        },
        shield: {
          img: goldShield,
          description:
            "An exceptional shield made of pure gold. Unlike typical shields, its unusual shape allows its wielders to launch devastating counter-attacks even in most dire situations.",
        },
      },
      badge: goldBadge,
      full: goldFull,
      palette: {
        primary: "#E7D600",
      },
      arena: arenaTravaGold,
      hand: goldHand,
      shirt: goldShirt,
      head: goldHead,
      sword: goldSword,
      shield: goldShieldV2,
      name: "gold",
      fullName: "Knight Officer",
      description:
        "Knight Officers are veteran knights: having fought in as many battles as their years walking on Earth. Not only are their skills honed to respectable level, their deep understanding of dragons and battle tactics is also of insurmountable importance to the survival of the Trava Kingdom.",
    },
    diamond: {
      units: {
        helmet: {
          img: diamondHelmet,
          description:
            "A helmet forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. As diamond is the perfect catalyst to contain holy magic, this helmet not only protects the wearer from attacks, but also enhances his visions in the dark - a trait most wanted when the sky is full of dragons.",
        },
        armor: {
          img: diamondArmor,
          description:
            "A armor forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. It offers invulnerability against dragon’s tooth and claws, and is also capable of exploding, expending all of its magical energy as a last resort.",
        },
        weapon: {
          img: diamondWeapon,
          description:
            "A mace forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. The mace is made of a diamond core and clad in a special alloy, allowing it to strike deep into dragon flesh and explode into an everlasting wound - should the dragon escape alive.",
        },
        shield: {
          img: diamondShield,
          description:
            "A shield forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool.  The shield is made of a diamond core and clad in a special alloy, allowing the wielder to absorb the dragon’s breath and release the absorbed energy in a highly concentrated beam.",
        },
      },
      badge: diamondBadge,
      full: diamondFull,
      palette: {
        primary: "#8125FF",
      },
      arena: arenaTravaDiamond,
      hand: diamondHand,
      shirt: diamondShirt,
      head: diamondHead,
      sword: diamondSword,
      shield: diamondShieldV2,
      name: "diamond",
      fullName: "Knight Commander",
      description:
        "Knight Commanders are officers who have fought at least an Elder Wyrm and walked out alive; and only those who are bravest, most fearless, most skillful and with deepest insight of the nature of these beasts could manage such a feat. As such, Knight Commanders are held in high regard by the people and the nobles, and are granted several special privileges by the King himself.",
    },
    crystal: {
      units: {
        helmet: {
          img: crystalHelmet,
          description:
            "This helmet is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. Not only does the helmet offer impeccable protection against any dragon’s magic, its wings also represent the collective hope of the entire Trava Kingdom’s history and heritage.",
        },
        armor: {
          img: crystalArmor,
          description:
            "This armor is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. An armor truly fits champions of the realm, it is nigh impenetrable - both from physical assaults and magical blasts. Ancient magicks imbued into the armor vastly enhance the wielder’s strength, enabling him to overpower even the likes of Elder Wyrms.",
        },
        weapon: {
          img: crystalWeapon,
          description:
            "This sword is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. Enchanted by mystic magicks, the sword is capable of cutting through the hide of Elder Wyrms, fully negating their regenerative power. At night, the sword radiates a calming blue, warding off any stray beast that dares to cross the legendary knight’s path.",
        },
        shield: {
          img: crystalShield,
          description:
            "This shield is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. The insignia of the Trava Kingdom, carved onto the surface by the finest blacksmiths, and enchanted by the most powerful sages, grants total fire and ice immunity, and acts as a beacon of light should knights lose their way in darkest nights.",
        },
      },
      badge: crystalBadge,
      full: crystalFull,
      palette: {
        primary: "#1C8CF3",
      },
      arena: arenaTravaCrystal,
      hand: crystalHand,
      shirt: crystalShirt,
      head: crystalHead,
      sword: crystalSword,
      shield: crystalShieldV2,
      name: "crystal",
      fullName: "Knight Grand Cross",
      description:
        "Knight Grand Cross, the pillars of the Order of the Holy Knight, is reserved for but a selected few, for one good reason: not only do they need to be chivalrous, but they must also prove themselves worthy to Vivianne, Goddess of the Pool. Only then, these knights are blessed with the Armor of the Crystal, forged by the crystallized essence of the Lending Pool, blessed with Vivianne’s magic, making them powerful enough to slay even an Elder Wyrm. The exact criteria of gauging one’s worthiness is yet unknown, but all Knight Grand Cross share one common trait: their hearts are as pure as the Lending Pool on a summer day.",
    },
  },
};

export const badgeAssetsMapping = {
  copper: copperBadge,
  silver: silverBadge,
  gold: goldBadge,
  diamond: diamondBadge,
  crystal: crystalBadge,
  limited: limitedBadge,
};

const specialCollectionAssetsMappingMainnet = {
  241221: {
    id: 241221,
    name: "TR-A Valor-1",
    img: noelNoBg,
    imgBg: noelBgFull,
    badge: noelBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "noel",
    description: `An ancient war machina unearthed from the ruins of the Southern Empty. Since its discovery, it has piqued the interests of Trava Kingdom’s Convocation of the Polytechnicians – where gathers the greatest minds in the kingdom.\n
    Not only are its inner workings completely strange, but its outer coat also poses serious questions with red and green stripes. Nevertheless, historians have agreed that the colours represent traditions of the distant past, most probably some sort of winter holiday.\n
    After months of analyzing and scrutinizing TR-A Valor-1, scientists of the Trava Kingdom have successfully activated and assumed complete control over the machina, deeming it combat ready to stand against the dragons - though they still wonder what Jingle Bells means every time the war machina boots up.
    `,
    set: "legendary",
    price: 2500000,
    type: "unique",
  },
  123321: {
    id: 123321,
    name: "TR-A Valor-1",
    img: noelNoBg,
    imgBg: noelBgFull,
    badge: noelBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "noel",
    description: `An ancient war machina unearthed from the ruins of the Southern Empty. Since its discovery, it has piqued the interests of Trava Kingdom’s Convocation of the Polytechnicians – where gathers the greatest minds in the kingdom.\n
    Not only are its inner workings completely strange, but its outer coat also poses serious questions with red and green stripes. Nevertheless, historians have agreed that the colours represent traditions of the distant past, most probably some sort of winter holiday.\n
    After months of analyzing and scrutinizing TR-A Valor-1, scientists of the Trava Kingdom have successfully activated and assumed complete control over the machina, deeming it combat ready to stand against the dragons - though they still wonder what Jingle Bells means every time the war machina boots up.
    `,
    set: "legendary",
  },
  220203: {
    id: 220203,
    name: "Sir Kuana of TraDAO",
    fullName: "Sir Kuana, Commander of TraDAO",
    img: todNoBg,
    imgBg: todBg,
    imgLarge: todBgFull,
    badge: todBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `Of all the things that are symbolic of the Trava Kingdom during the hundred year Draconic War, few are as iconic as the Order of TraDAO.\n
    TraDAO Knights - a selection of only the best Knights ever dawned upon the Kingdom - are specialized in aerial combat, and all have shed their heavy armors to adapt an extremely lightweight version forged with stellarium ore, trading off defense for the ability to soar and battle the dragons right on their home field: the vast sky.\n
    Currently, the Commander of the Order is Sir Kuana Audovera, Knight Commander of Trava Kingdom. Having slain countless lesser dragons and survived confrontation with two Elder Wyrms himself, Sir Kuana proves to be a legend among legends, a man who younglings of Trava Kingdom idolize and strive to become. But inside his heart, a fire of hatred and despair rages still, for he has not found Tryss the Blazing Elder Wyrm, who killed his wife and son fifteen years ago, and yet he walks on, ever on the path of vengeance.
    `,
    set: "legendary",
    price: 2500000,
    type: "unique",
  },
  222605: {
    id: 222605,
    name: "Dame Johanna",
    fullName: "Dame Johanna, Shield of the Twelve",
    img: johannaNoBg,
    imgBg: johannaBg,
    imgLarge: johannaBgFull,
    badge: johannaBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `'I am thy shield, my liege, for now and forevermore.'\n
    Johanna was born to a family of knighthood, and was raised along with swords and shields. Then the Draconic War came, and her parents, a Knight Officer and a Healer, perished in the Battle of Iorela. She was then given a conviction: to serve in the Holy Knight Order, to protect the Kingdom… and her little brother.\n
    Bearing that conviction, she trained and trained, and with exceptional talents, she graduated as the top of the Royal Knight Academy. Through battles and battles, she proved to be a master of the shield, using it to stop every attack launched at her and her comrades. Acknowledging her skills, King Svitanae personally appointed her into the Twelve, the council of the strongest Knights of Trava Kingdom, and she held the seat of The Shield, whose primary job is to guard King Svitanae from the unforeseen forces.\n
    Thus, the legend of Dame Johanna, Shield of the Twelve, a woman with unparalleled beauty but incredible fierceness, was born.`,
    set: "legendary",
    price: 3000000,
    type: "unique",
  },
  222406: {
    id: 222406,
    name: "Aleister",
    fullName: "Aleister, Eye of the Twelve",
    img: aleisterNoBg,
    imgBg: aleisterBg,
    imgLarge: aleisterBgFull,
    badge: aleisterBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `Before the Draconic War, King Svitanae had searched for a specific individual, a person of incredible intelligence that was capable of deciphering the Book of DAO, a sacred book that could even change the foundation of Trava Kingdom itself.\n
    This individual was called Aleister, a young lad hailed from the remote village on the Island of Costa del Paraiso. In pursuit of knowledge, he set out on a journey, from the borders of Iorela to the forbidden library in Hollowbane, where he met King Svitanae. \n“Duel with me for a match of chess.” - King Svitanae offered. After a fierce battle that lasted two hours, Aleister emerged victorious.\n
    “Thou lose, old man.”\n
    “Thy talent is indisputable, young lad. Want a spot in The Twelve?”\n
    “Are there books there?”\n
    “The Royal Library has plenty.”\n
    Thus, Aleister joined The Twelve, the council of the strongest Knights of Trava Kingdom, albeit not exactly a Knight yet himself. \n
    The legend of Aleister, Eye of the Twelve, was thus born, a young man with the eye of azure, holder of the Book of DAO, who secretly steered the Trava Kingdom and the very course of history from the shadows.`,
    set: "legendary",
    price: 3000000,
    type: "unique",
  },
  222607: {
    id: 222607,
    name: "Medivh",
    fullName: "Medivh, Ambassador of Techfian Principality",
    img: techfiNoBg,
    imgBg: techfiBg,
    imgLarge: techfiBgFull,
    badge: techfiBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `Techfian Principality was a small nation that existed in the far east of the Crypto World, renowned by their impressive records of history of Crypto World, as well as the fundamental understanding of how Crypto World functioned.\n
    Seeking knowledge, King Svitanae had visited Techfian Principality on various occasions, at times indulged himself into the Central Library, the largest library containing every discovered fact of Crypto World, at times admired the beautiful scenery and the hospitality of Techfians.\n
    Having heard that Trava Kingdom was in grave danger posed by Dragons of the North, Crown Prince of Techfian had sent Medivh of Belfalas, head of the Central Library, a sage of incredible erudition to Trava Kingdom.\n
    Medivh's job was not to participate in direct combat, but to enlighten Trava people, providing them crucial knowledge about the Crypto World, and with his wisdom, citizens of Trava Kingdom would have yet another weapon to defeat the wicked dragons.\n`,
    set: "legendary",
    price: 3000000,
    type: "unique",
  },
};

const specialCollectionAssetsMappingTestnet = {
  135246: {
    id: 135246,
    name: "TR-A Valor-1",
    img: aleisterNoBg,
    imgBg: aleisterBg,
    imgLarge: aleisterBgFull,
    badge: noelBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `An ancient war machina unearthed from the ruins of the Southern Empty. Since its discovery, it has piqued the interests of Trava Kingdom’s Convocation of the Polytechnicians – where gathers the greatest minds in the kingdom.\n
    Not only are its inner workings completely strange, but its outer coat also poses serious questions with red and green stripes. Nevertheless, historians have agreed that the colours represent traditions of the distant past, most probably some sort of winter holiday.\n
    After months of analyzing and scrutinizing TR-A Valor-1, scientists of the Trava Kingdom have successfully activated and assumed complete control over the machina, deeming it combat ready to stand against the dragons - though they still wonder what Jingle Bells means every time the war machina boots up.
    `,
    set: "legendary",
    price: 2500000,
    type: "unique",
  },
};

export const specialCollectionIdListForSell = environment == "mainnet" ? [241221, 220203, 222605] : [135246];
export const specialCollectionIdList = environment == "mainnet" ? [241221, 220203, 222605, 222406, 222607] : [135246];
export const specialCollectionAssetsMapping =
  environment == "mainnet" ? specialCollectionAssetsMappingMainnet : specialCollectionAssetsMappingTestnet;

export default knightAssetsMapping;
